export const SCROLL_MARGIN = 8;
export const MIN_HEIGHT_LINES = 15;
export const MIN_EDITOR_HEIGHT_AFTER_DRAGGING = 0;
export const THRESHOLD_FOR_AUTO_CLOSE = 50;
